import stevenJ from "./orators/steven_j.jpg";
import drLouie from "./orators/dr_louie.jpg";
import drGeralad from "./orators/dr_geralad.jpg";
import camila from "./orators/camila.jpg";

import steven_banner from "./orator_banners/steven_j.jpg";
import camila_banner from "./orator_banners/prof_camila.jpg";
import gerald_banner from "./orator_banners/dr_geralad.jpg";
import louie_banner from "./orator_banners/dr_louie.jpg";

export const orators = [
  {
    id: "steven-j-traub",
    image: stevenJ,
    name: "Dr. Steven J. Traub",
    from: "United States",
    about: "American Institute of Oral Biology",
    link: "/orators/steven-j-traub",
  },
  {
    id: "camila-paiva-perin",
    image: camila,
    name: "Prof. Dr. Camila Paiva Perin",
    from: "Brazil",
    about: "University Tuiuti do Paraná",
    link: "/orators/camila-paiva-perin",
  },
  {
    id: "gerald-c-green",
    image: drGeralad,
    name: "Dr. Gerald C. Green",
    from: "United States",
    about: "Lancaster General Hospital",
    link: "/orators/gerald-c-green",
  },
  {
    id: "gregory-louie",
    image: drLouie,
    name: "Dr. Gregory Louie",
    from: "United States",
    about: "Tri Valley Implant Study Group",
    link: "/orators/gregory-louie",
  },
];

export const steven_data = {
  image: stevenJ,
  from: "American Institute of Oral Biology, United States",
  about:
    "Dr. Traub graduated from Creighton University School of Dentistry in 1978 following which he completed a 3-year Oral & Maxillofacial Surgery residency at Cook County Hospital in Chicago, Illinois, USA. He then enjoyed a full-time solo practice in his home town of Albuquerque, New Mexico USA until the summer of 2023. More recently, he has accepted a teaching position at Creighton University Dental School as a clinical professor in the Oral & Maxillofacial Surgery department. He is on the Board of Directors of the American Institute of Oral Biology (AIOB), still practices surgery part-time in Albuquerque, and is becoming certified by the International Academy of Independent Medical Legal Evaluators, being the first in his field in that organization. He has placed dental implants since 1982 and still does major facial traumatic reconstructive surgery.",
  name: "Dr. Steven J. Traub",
  banner: steven_banner,
};

export const camila_data = {
  image: camila,
  from: "University Tuiuti do Parana, Brazil",
  about:
    "Prof. Dr. Camila Paiva Perin is Dentist graduated from the Federal University of Paraná - Brazil, Specialist (Sp), Master (Md) and Doctor (Ph.D.) in Endodontics and specialist in Public Health. She is a tutor of the Dentistry Course at the University Tuiuti of Parana -Brazil, in the disciplines of Endodontics, Collective Health, and Dental Clinic, as well as being a Coordinator of the Endodontics Specialization Course at the same University. She is Dentist of the Unified Health System (SUS - Brazilian public health service) in the city of Curitiba - Paraná - Brazil. She has experience in the area of Dentistry, with emphasis on Endodontics and Public Health, working mainly on the following topics: dental trauma, regenerative techniques in Endodontics, Endodontics in Public Health and Paraendodontic Surgery.",
  name: "Prof. Dr. Camila Paiva Perin",
banner: camila_banner,
};

export const gerald_data = {
  image: drGeralad,
  from: "Lancaster General Hospital, United States",
  about:
    "Dr. Green maintains a full-time periodontal practice in Lancaster Pennsylvania. He is member of numerous dental organizations and a leader for his Spear study club. He has been the periodontal preceptor for the Lancaster General Hospital GPR since 2012. In addition to mucogingival surgery, Dr. Green also performs a multitude of other procedures including bone regeneration, the placement of dental implants and he is a certified LANAP practitioner. In his spare time he enjoys playing golf and traveling with his wife Aurora.",
  name: "Dr. Gerald C. Green",
  banner: gerald_banner,
};

export const louie_data = {
  image: drLouie,
  from: "Tri Valley Implant Study Group, United States",
  about:
    "Dr. Louie started his dental experience as a dental technician before receiving his dental degree from the University of the Pacific in 1986 in San Francisco, CA. After practicing as a General Dentist for several years, Dr. Louie completed advanced training in dental implants at Brookdale Hospital in Brooklyn, NY, before completing advanced specialty training in Prosthodontics at the University of Illinois at Chicago. He created the Tri Valley Implant Study Group Implant Continuum in 2013. He holds memberships with the ADA, CDA, ACP, AACD, AAID, ICOI, and AO.",
  name: "Dr. Gregory Louie",
  banner: louie_banner,
};
